import { migrationContext } from '../../migrationUsersBranchView.poeditor';

export const termsKeys = {
  headerLeftText: `${migrationContext}-mbMigrationHeaderSignTheContracts`,
  title: `${migrationContext}-mbMigrationTermsAndConditionsTitle`,
  cancelLink: `${migrationContext}-mbMigrationCancelLink`,
  continueButton: `${migrationContext}-mbMigrationContinueButton`,
  viewerDescription: `${migrationContext}-mbMigrationTermsAndConditionsDescription`,
  contractualInfoCheckboxText: `${migrationContext}-mbMigrationContractualInformationCheckbox`,
  dataProtectionCheckboxText: `${migrationContext}-mbMigrationDataProtectionCheckbox`,
  dataProtectionCheckboxText2: `${migrationContext}-mbMigrationDataProtectionCheckbox2`,
  optionalConsentCheckboxText: `${migrationContext}-mbMigrationOptionalConsentCheckbox`,
  dataProtectionLink: `${migrationContext}-mbMigrationDataProtectionLink`,
  preContractPdfFileName: `${migrationContext}-preContractPdfFileName`,
  readyLink: `${migrationContext}-mbMigrationPdfViewerHybridReadyLink`,
};
